import { EcosystemOrbit } from "../components/EcosystemOrbit";
import { motion } from "framer-motion";

const ABOUT_HERO = "https://customer-assets.emergentagent.com/job_fincorp-strategy/artifacts/hdb863ii_ChatGPT%20Image%20Jun%2012%2C%202026%2C%2011_28_13%20AM.png";

const stats = [["20+", "Years of Legacy"], ["40+", "Brands & growing"], ["500+", "Locations"], ["10K+", "Team Strength"]];

export default function About() {
  return (
    <div data-testid="about-page">
      {/* FULL-BLEED HERO */}
      <section className="relative min-h-[92vh] flex items-center overflow-hidden border-b border-white/10">
        {/* background image */}
        <img src={ABOUT_HERO} alt="A monolith rising from still waters, lit gold" className="absolute inset-0 w-full h-full object-cover object-right" />
        {/* legibility overlays — dark on the left, fades toward the lit subject on the right */}
        <div className="absolute inset-0" style={{ background: "linear-gradient(90deg, #050B14 0%, rgba(5,11,20,0.92) 30%, rgba(5,11,20,0.55) 55%, rgba(5,11,20,0.05) 80%)" }} />
        <div className="absolute inset-0" style={{ background: "linear-gradient(0deg, #050B14 0%, rgba(5,11,20,0) 35%)" }} />

        <div className="relative px-6 md:px-12 lg:px-20 py-24 w-full">
          <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} className="max-w-2xl">
            <p className="eyebrow mb-5">About EBG</p>
            <h1 className="font-display text-5xl md:text-7xl text-white tracking-tight leading-[1.02]">
              Building iconic brands.<br /><span className="gold-text italic">Creating lasting value.</span>
            </h1>
            <p className="text-ebg-muted mt-7 text-lg leading-relaxed max-w-xl">
              Like a monolith rising from still waters, EBG Group is built to endure — a diversified conglomerate forging
              category-defining brands across high-growth sectors, owned and operated under one house.
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-x-8 gap-y-6 mt-12 max-w-xl">
              {stats.map(([n, l], i) => (
                <motion.div key={l} initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3 + i * 0.1 }}>
                  <p className="font-display text-4xl md:text-5xl gold-text leading-none">{n}</p>
                  <p className="text-[0.65rem] uppercase tracking-widest text-ebg-muted mt-2">{l}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>

      {/* ECOSYSTEM */}
      <section className="px-6 md:px-12 lg:px-20 py-20 md:py-28 border-b border-white/10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <p className="eyebrow mb-4">One Ecosystem</p>
            <h2 className="font-display text-4xl md:text-5xl text-white leading-tight">A single house of <span className="gold-text">category-defining brands.</span></h2>
            <p className="text-ebg-muted mt-6 text-lg leading-relaxed max-w-xl">
              From food & beverage to wellness, hospitality, education and retail — every EBG brand is built, owned and
              operated within one integrated ecosystem. That is what makes the franchise partner model here different.
            </p>
          </div>
          <EcosystemOrbit center="EBG" label="GROUP" />
        </div>
      </section>

      {/* FOUNDER */}
      <section className="px-6 md:px-12 lg:px-20 py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 items-center">
          <div className="relative rounded-2xl overflow-hidden border border-white/10 aspect-[4/5]">
            <img src="https://customer-assets.emergentagent.com/job_fincorp-strategy/artifacts/lmuej2f5_irfan.jpg" alt="Irfan, Founder & CEO, EBG Group" data-testid="founder-image" className="w-full h-full object-cover object-top" />
            <div className="absolute inset-0 bg-gradient-to-t from-navy-950/80 to-transparent" />
          </div>
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="lg:col-span-2">
            <p className="eyebrow mb-4">Founder's Message</p>
            <blockquote className="font-display text-2xl md:text-4xl text-white leading-snug italic">
              "At EBG, we believe in building businesses that create lasting impact for generations. EBG FinCorp is an extension of this belief—empowering franchise partners to grow alongside us."
            </blockquote>
            <div className="mt-8">
              <p className="font-display text-3xl gold-text italic" data-testid="founder-name">Irfan</p>
              <p className="text-sm text-ebg-muted mt-1">— Founder &amp; CEO, EBG Group</p>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
